<script>
import { required, numeric } from "vuelidate/lib/validators";
import validationMessages from "@/components/validations";
import Merchandising from "@/services/Merchandising";
import Swal from "sweetalert2";

export default {
  props:['id'],
  components: { validationMessages },

  data() {
    return {
      brand_name: "",
      showModal: false,
      submitted: false,
      tryingToSubmit: false,
      showLoader: false,
      csrf_token: localStorage.getItem("csrf_token"),
      termNames:'',
    };
  },

  validations: {
    termNames: { required },

  },


  methods: {
    async submitForm() {
      this.tryingToSubmit = true;

      if (this.$v.$invalid) {
        this.submitted = true;
        this.tryingToSubmit = false;
        return;
      }

      const names = this.termNames
          .split(/[\n,]+/)   // split only on newline OR comma
          .map(name => name.trim())
          .filter(name => name);

      this.showLoader = true;
      const data = {
        attr_id: this.id,
        names: names,
      }
      try {
        const response = await Merchandising.addBulkTerms(data);
        if (response.success === false) {
          Swal.fire("Error", response.error || "Failed to create term. Please try again.", "error");
        } else {
          Swal.fire("Success", "Term successfully added!", "success");
          this.closeModal();
          this.refreshData();
        }

      } catch (error) {
        // Catch any network or unexpected errors
        console.error("Failed to create term:", error);
        Swal.fire("Error", error.response?.data?.error || "Failed to create term. Please try again.", "error");
      } finally {
        this.tryingToSubmit = false;
        this.showLoader = false;
      }
    },
    resetForm() {
      this.$v.$reset();
      this.termNames = '';
    },
    closeModal() {
      this.resetForm();
      this.showModal = false;
    },

    refreshData() {
      this.$emit("onRefresh");
    },
  },
};
</script>

<template>
  <b-modal
      @hidden="resetForm"
      id="add_terms_to_attribute"
      size="l"
      v-model="showModal"
      title="Add Term"
      title-class="font-18"
  >
    <form @submit.prevent="submitForm">
      <div class="row">
        <div v-if="$v.$error" class="text-danger">Complete all fields</div>
        <div v-if="showLoader" class="card-body d-flex align-items-center justify-content-center">
          <b-spinner large></b-spinner>
        </div>
        <div v-else>
          <b-card-text>
            <b-form-group label="Term Name" class="mb-3">
              <b-form-textarea
                  v-model.trim="termNames"
                  :class="{ 'is-invalid': submitted && $v.termNames.$error }"
              ></b-form-textarea>
              <validationMessages
                  v-if="submitted"
                  :fieldName="'Term Name'"
                  :validationName="$v.termNames"
              ></validationMessages>
            </b-form-group>

          </b-card-text>
        </div>
      </div>
    </form>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
      <b-button variant="primary" @click="submitForm" :disabled="tryingToSubmit || showLoader">
        <b-spinner v-show="tryingToSubmit" small></b-spinner>Submit
      </b-button>
    </template>
  </b-modal>
</template>
